export default {
  needEmailVerification(state) {
    return (
      !state.disableEmailVerification &&
      !state.skipEmailVerification &&
      state.isEmailVerified === '0' &&
      state.isPaidAccount === '0'
    );
  },
  currentMethod(state) {
    return state.choseMethod || state.defaultMethod;
  },
  hasBackup(state) {
    return state.availableMethod.length > 1;
  },
  otherMethods(state) {
    const availableMethods = [...state.availableMethod];
    availableMethods.shift();
    return availableMethods;
  },
};
